import ReviewerSidebar from "../components/ReviewerSidebar";
import SettingsLayout from "../components/settings/SettingsLayout";
import SettingsSections from "../components/settings/SettingsSections";

export default function ReviewerSettings() {
  const role = (() => {
    try {
      return JSON.parse(localStorage.getItem("user"))?.role;
    } catch {
      return undefined;
    }
  })();

  return (
    <SettingsLayout Sidebar={ReviewerSidebar}>
      <SettingsSections role={role} />
    </SettingsLayout>
  );
}
